export default function NormalizeDynamoDBItem(item) {
    if (!item || typeof item !== 'object') return item;

    // Handle DynamoDB types
    if ('N' in item) return Number(item.N);
    if ('S' in item) return item.S;
    if ('BOOL' in item) return item.BOOL;
    if ('NULL' in item) return null;
    if ('L' in item) return item.L.map(i => NormalizeDynamoDBItem(i));
    if ('M' in item) {
        const obj = {};
        Object.entries(item.M).forEach(([key, value]) => {
            obj[key] = NormalizeDynamoDBItem(value);
        });
        return obj;
    }

    // If it's a regular object, process all its values
    if (Array.isArray(item)) {
        return item.map(i => NormalizeDynamoDBItem(i));
    }

    const obj = {};
    Object.entries(item).forEach(([key, value]) => {
        obj[key] = NormalizeDynamoDBItem(value);
    });
    return obj;
}